import * as Common from '@/tenant/common';

export class Conversion extends Common.MasterBase{
  constructor(){
    super('Conversion')
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);    
  }
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public code: string = '';
  public name: string = '';
  public rate: number = 1;
  public netWeight: number = 0;
  public grossWeight: number = 0;
  public measurement: number = 0;

  public copy():any {
    const temp = super.copy() as Conversion;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export class ConversionQuery extends Common.LoadQuery {
  constructor(){
    super('ConversionQuery',Conversion);
    this.sort = 'code';
  }

  public commodityCode: string = '';
  public commodityName: string = '';  
  public commodity: Common.Commodity = null;
  public code: string = '';
  public name: string = '';
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class ConversionMasterQuery extends Common.LoadQuery {
  constructor(){
    super('ConversionMasterQuery',Conversion);
  }
  public commodity: Common.Commodity = null;
}


export class ConversionImportQuery extends Common.ImportQuery {
  constructor(sheetName:string){
    super(sheetName,'');
    this.className = 'ConversionImportQuery';
  }
  public hasLicenseCurrency: boolean = false;
}

export class ConversionExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super(sheetName,loadQuery);
    this.className = "ConversionExportQuery";
  }
  public hasLicenseCurrency: boolean = false;
}